<div style="position:absolute;left:50%;top:70px;z-index:1003">
  <saLoader></saLoader>
</div>
<div style="position:absolute;right:0px;top:80px;max-width:500px;z-index:1003">
  <app-toast></app-toast>
</div>
<app-navigation></app-navigation>

<app-alert></app-alert>
<div style=" position: fixed;top: 50%;left: 50%;min-width:1000px;margin-top: -250px;margin-left: -500px;z-index:1003">
  <app-confirm></app-confirm>
</div>
<router-outlet></router-outlet>